<template>
  <div>
    <!-- <div class="filter-button">Filter</div> -->
    <div class="filter-container">
      <v-container grid-list-sm>
      <v-layout row wrap>
      <v-flex xs12>
        <v-autocomplete
          v-model="query"
          :items="searchList"
          chips
          color="blue-grey lighten-2"
          label="Search wells, state, operators ..."
          item-text="code"
          item-value="name"
          clearable
          outlined
        >
          <template v-slot:item="data">
            <v-list-tile-content>
              <v-list-tile-title
                v-html="data.item.name"
              ></v-list-tile-title>
              <v-list-tile-sub-title
                v-html="data.item.type"
              ></v-list-tile-sub-title>
            </v-list-tile-content>
          </template>
        </v-autocomplete>
      </v-flex>
      <template>
        <v-flex xs12>
          <h3>Label </h3>
        </v-flex>
        <v-flex xs6>
          <v-text-field
            label="Regular"
            placeholder="Placeholder"
            type="number"
            clearable
          ></v-text-field>
        </v-flex>
        <v-flex xs6>
          <v-text-field
          
            label="Regular"
            placeholder="Placeholder"
            clearable
          ></v-text-field>
        </v-flex>
      </template>
      </v-layout>
      </v-container>
    </div>
  </div>
</template>
<script>
import { createNamespacedHelpers } from "vuex";
const oilNamespace = createNamespacedHelpers("oil");

export default {
  props: ["filter"],
  data() {
    return {
      query: '',
    };
  },
  computed: {
    // ...dataSourceNamespace.mapState(['dataSources']),
    ...oilNamespace.mapState({
      searchList: (state) => state.searchList,
    }),
  },
};
</script>
<style scoped>
.filter-container {
  position: fixed;
  top: 100px;
  left: 10px;
  width: 400px;
  height: 700px;
  background: #fff;
}
.filter-button {
  background: #13365b;
  color: #fff;
  font-size: 22px;
  position: relative;
  left: -30px;
  top: 45%;
  padding: 10px 30px;
  z-index: 1000;
  transform: rotate(-90deg);

  /* Legacy vendor prefixes that you probably don't need... */

  /* Safari */
  -webkit-transform: rotate(-90deg);

  /* Firefox */
  -moz-transform: rotate(-90deg);

  /* IE */
  -ms-transform: rotate(-90deg);

  /* Opera */
  -o-transform: rotate(-90deg);

  /* Internet Explorer */
  filter: progid:DXImageTransform.Microsoft.BasicImage(rotation=3);
}
</style>